import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { SAFETY_CHECKLIST_API } from "../apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseGetSafetyChecklistWithItemByProjectProps {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getSafetyChecklistWithItemByProject = async (projectId: string) => {
  return await axiosAuth.get(`${SAFETY_CHECKLIST_API}/project/${projectId}/with-items`);
};

const useGetSafetyChecklistWithItemByProject = ({
  projectId,
  queryParams,
}: UseGetSafetyChecklistWithItemByProjectProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["safety-checklist-with-item", projectId],
    queryFn: () => getSafetyChecklistWithItemByProject(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetSafetyChecklistWithItemByProject;
